import React, { useContext, useEffect, useState } from 'react'
import { LocaleContext } from '../../contexts/LocaleContext';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from '../../services/toastService';
import { useValidation } from '../../hooks/useValidation';
import { createCountrySchema } from '../../validation/countrySchema';
import { countryService } from '../../services/countryService';
import Loading from '../../components/common/Loading';
import BackButton from '../../components/common/BackButton';

const CountryForm = () => {

    const {t} = useContext(LocaleContext);
    const { id } = useParams();
    const isEditMode=Boolean(id);
    const navigate = useNavigate();
    const [btnLoading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const initialForm = {
      name: "",
      nameEn: "",
      order: 1,
      isActive: true,
    };

    const v = useValidation();
    const schema = createCountrySchema(v, t, isEditMode);

    useEffect(()=>{
         if (isEditMode) editAsync();
    },[]);

    //validation
        const {
          register,
          handleSubmit,
          reset,
          formState: { errors },
        } = useForm({
          defaultValues: initialForm,
          resolver: yupResolver(schema),
        });

         const handleClear = () => {
           reset(initialForm); // resets to initial values
         };

        const onSubmit = async (values) => {
          try {
            const payload = {
              name: values.name,
              nameEn: values.nameEn,
              order: Number(values.order),
              isActive: values.isActive,
            };
            if (isEditMode) {
             await updateAsync(payload);
            } else {
              await addAsync(payload);
            }
          } catch (error) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(error);
          }
        };
        const addAsync = async (payload) => {
          try {
            setBtnLoading(true);
            var response = await countryService.create(payload);
            if (!response.isSuccess) {
              response.key?toast.error(t(response.key)): toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              console.log(response);
              return;
            }
            toast.success(t("recordAddedSuccessfully"));
            navigate("/countries");
          } catch (error) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(error);
          } finally {
            setBtnLoading(false);
          }
        };
         const editAsync = async () => {
            const response = await countryService.edit(id);

            if (!response.isSuccess) {
              toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              console.log(response);
              return;
            }
            const data = response.value;
            reset({
              name: data.name,
              nameEn: data.nameEn,
              order: data.order,
              isActive: data.isActive,
            });
          };
        const updateAsync = async (payload) => {
          try {
            setBtnLoading(true);
            var response = await countryService.update(id, payload);
            if (!response.isSuccess) {
               response.key
                 ? toast.error(t(response.key))
                 : toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              console.log(response);
              return;
            }
            toast.success(t("recordUpdatedSuccessfully"));
            navigate("/countries");
          } catch (error) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(error);
          } finally {
            setBtnLoading(false);
          }
        };

if(loading) return <Loading />
  return (
    <>
      <section className="provider-form">
        <div className="default-heading">
          {t("providersDashboardAndManagement")}
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="my-card">
            <div className="my-card-header d-flex justify-content-between align-items-center">
              {isEditMode ? (
                <>
                  <i className="fas fa-edit"></i> {t("editOrSelectedNarrator")}
                </>
              ) : (
                <>
                  <i className="fas fa-plus plus-icon"></i>{" "}
                  {t("addNewCountry")}
                </>
              )}
              <BackButton />
            </div>
            <div className="my-card">
              <div className="my-card-header text-primary">
                {t("basicInformation")}
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">
                      {t("name")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      {...register("name")}
                      className="form-control"
                      placeholder={t("name")}
                    />
                    {errors.name && (
                      <p className="text-danger">{errors.name.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">
                      {t("nameEn")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("nameEn")}
                      {...register("nameEn")}
                    />
                    {errors.nameEn && (
                      <p className="text-danger">
                        {errors.nameEn.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">
                      {t("order")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder={t("order")}
                      {...register("order")}
                    />
                    {errors.order && (
                      <p className="text-danger">
                        {errors.order.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-3 gap-2 d-flex justify-content-end">
              {!btnLoading && (
                <button type="submit" className="btn-default">
                  {t("save")}
                </button>
              )}
              {btnLoading && (
                <button type="button" className="btn-default">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </button>
              )}
              {isEditMode && (
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={handleClear}
                >
                  {t("reset")}
                </button>
              )}
              {!isEditMode && (
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={handleClear}
                >
                  {t("reset")}
                </button>
              )}
            </div>
          </div>
        </form>
      </section>
    </>
  );
}

export default CountryForm
